import { useQuery } from '@tanstack/react-query';
import { profileClient } from 'api/MinSideClients';

export const currentUserQueryKey = ['currentUser'];

// Delt cache for innlogget brukerprofil, slik at ruteguarden ser oppdatert arbeidsgiver
// uten at siden må lastes på nytt. Invalider nøkkelen når profilen endres.
export function useCurrentUserQuery(enabled: boolean) {
  return useQuery({
    queryKey: currentUserQueryKey,
    enabled,
    queryFn: () => profileClient.apiProfileCurrentGet()
  });
}
